import React from 'react';
import { Section } from './ui/Section';
export function ProblemSection() {
  return <>
      {/* Block 1: The Real Problem */}
      <Section background="night-900" data-id="element-88">
        <div className="text-center mb-12" data-id="element-89">
          <span className="text-gold-500 text-sm font-bold tracking-widest uppercase border-b border-gold-500 pb-1" data-id="element-90">
            The Real Problem
          </span>
        </div>

        <h2 className="font-serif text-3xl md:text-4xl text-white mb-8 text-center" data-id="element-91">
          Here's what nobody tells you about chronic insomnia:
        </h2>

        <div className="prose prose-lg prose-invert mx-auto text-slate-300" data-id="element-92">
          <p className="text-xl font-medium text-white mb-6" data-id="element-93">
            You don't have a sleep problem. You have a symptom problem.
          </p>

          <p className="mb-6" data-id="element-94">
            That racing mind at 2 AM isn't the issue, it's the furthest branch
            of something deeper. The anxiety about not sleeping? Also a branch.
            Even the physical restlessness keeping you awake for hours? Still
            just a visible symptom of a root you haven't identified yet.
          </p>

          <p className="mb-6" data-id="element-95">
            This is why{' '}
            <span className="text-gold-500 italic" data-id="element-96">
              melatonin works for three nights then stops
            </span>
            . Why the expensive magnesium supplement helped your friend but did
            nothing for you. Why cognitive behavioral therapy (CBT-I) cleared
            things up for six weeks before everything came rushing back.
          </p>

          <p className="text-lg border-l-2 border-gold-500 pl-6 italic text-slate-200 my-8" data-id="element-97">
            You weren't treating the wrong symptoms. You were treating symptoms
            AS IF they were roots.
          </p>
        </div>
      </Section>

      {/* Block 2: The Symptom Cascade */}
      <Section background="night-950" data-id="element-98">
        <div className="text-center mb-12" data-id="element-99">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-100">
            The Symptom Cascade
          </h2>
          <div className="w-24 h-0.5 bg-gold-500 mx-auto opacity-50" data-id="element-101"></div>
        </div>

        <div className="prose prose-lg prose-invert mx-auto text-slate-300" data-id="element-102">
          <p className="mb-6" data-id="element-103">
            There's an invisible enemy sabotaging your sleep recovery.
          </p>

          <p className="mb-6" data-id="element-104">
            It's called the{' '}
            <strong className="text-white" data-id="element-105">Symptom Cascade</strong>, and it's
            the reason you've been trapped in an exhausting cycle where fixing
            one problem spawns three more.
          </p>

          <p className="mb-6" data-id="element-106">
            You solve the racing thoughts with meditation, but now you're waking
            up with tension headaches. You fix the headaches with muscle
            relaxation, but now your anxiety about sleep itself has gotten
            worse. You address the anxiety with therapy, but suddenly you're
            dealing with digestive issues that keep you up.
          </p>

          <p className="mb-8 font-medium text-white" data-id="element-107">
            Different problems. Different solutions. Same 3 AM ceiling stare.
          </p>

          <p className="mb-8" data-id="element-108">
            The Symptom Cascade keeps you perpetually firefighting because it
            tricks you into treating visible problems as root causes. You see
            insomnia, so you target sleep. But insomnia isn't the dandelion,
            it's just the yellow flower everyone can see. The stem goes deeper.
            And beneath that stem is a branching taproot system feeding not just
            your sleep problems, but four other issues you've been treating
            separately.
          </p>

          <p className="mb-10" data-id="element-109">
            This is why your bathroom cabinet looks like a supplement store. Why
            you have seven different evening routines you rotate through. Why
            you can explain your insomnia in clinical detail but still can't fix
            it.
          </p>

          <blockquote className="font-serif text-2xl md:text-3xl text-gold-500 italic leading-relaxed border-l-4 border-gold-500 pl-6 py-2 my-12 bg-gold-500/5 pr-4 rounded-r-lg" data-id="element-110">
            "You've been mowing dandelions while the roots multiply
            underground."
          </blockquote>
        </div>
      </Section>
    </>;
}